<template>
<div class="router-transitions">
    <div class="cui-example cui-example-vertical-spacing">
      <b-card>
        <div class="row">
          <div class="col-md-6">
            <img :src="img" style="height: 20rem;
    margin: 10% auto;">
          </div>
          <div class="col-md-6">
            <div style="margin: 10%">
              <div v-html="header"></div>
              <div v-html="content"></div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main',
  props: {
    img: {
      type: String,
      default: ''
    },
    header: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>

</style>
